import { useState, useEffect, useCallback } from 'react';

export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    width: typeof window !== 'undefined' ? window.innerWidth : 1024
  });

  const checkScreenSize = useCallback(() => {
    if (typeof window === 'undefined') return;
    
    const width = window.innerWidth;
    setScreenSize({
      isMobile: width < 768,    // sm breakpoint
      isTablet: width >= 768 && width < 1024,  // md to lg breakpoint
      isDesktop: width >= 1024, // lg breakpoint
      width
    });
  }, []);

  useEffect(() => {
    // Check on mount
    checkScreenSize();

    // Add event listener for window resize with debouncing
    let timeoutId;
    const debouncedResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(checkScreenSize, 100);
    };

    window.addEventListener('resize', debouncedResize);

    // Cleanup event listener
    return () => {
      window.removeEventListener('resize', debouncedResize);
      clearTimeout(timeoutId);
    };
  }, [checkScreenSize]);

  return screenSize;
};
